import React, { Component, PropTypes } from 'react';

class ImageMessage extends Component {
  static propTypes = {
    imageGuid: PropTypes.string,
    image: PropTypes.string,
    imageId: PropTypes.number,
    imageUrl: PropTypes.string,
    imageComments: PropTypes.string,
    onShowImage: PropTypes.func.isRequired,
  };
  constructor(props) {
    super(props);

    this.state = {
      imageDownloaded: true,
    };
  }
  render() {
    let { state, props } = this;
    return (
      <div className="uploadedimage-message-wraper">
        {
          state.imageDownloaded ? (
            <div className="uploadedimage-message-thumbnail" onClick={props.onShowImage}>
              <img src={props.image ? `data:image/png;base64, ${props.image}` : props.imageUrl} />
            </div>
          ) : undefined
        }
        {props.imageComments ? <p className="uploadedimage-comments">{props.imageComments}</p> : undefined}
      </div>
    );
  }
}

export default ImageMessage;



// WEBPACK FOOTER //
// ./components/chat/fileUpload/ImageMessage.js